import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/mapaAN/step2';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeDescMarche } from '../../models/TypeDescMarche';

@Component({
  selector: 'app-step2',
  templateUrl: './step2.component.html'
})
export class Step2Component implements OnInit {

  
  private LOG: LogService = new LogService(Step2Component);

	@Input() description: TypeDescMarche;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() uid = '';
  @Input() linkForRouter: string;


  constructor(
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService
  ) {
    this.description = new TypeDescMarche();
   }

  ngOnInit(): void {
  }

  public step2 = new Step2();

  getUid(){
    return this.uid;
  }
}
